import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Card, Flex, Text } from '../../Components'
import errorImage from '../../Resources/errorHandlerImg.png'
import { COLORS } from '../../Components/Common/designSystem'

function ErrorHandler () {
  const navigateHome = useNavigate()
  return (
    <Flex pageW style={{ gap: '1em', justifyContent: 'center', minWidth: 992 }}>
      <Card darker style={{ gap: '1em', marginTop: 10, width: '80%' }}>
        <Flex row style={{ gap: '1em', justifyContent: 'center', alignItems: 'stretch' }}>
          <Flex jb as style={{ padding: '2em 2em 2em 2em', width: '45%' }}>
            <Flex fw as style={{ position: 'relative' }}>
              <Text upCase style={{ fontSize: '160px', fontWeight: 'bold', color: '#1e293b', marginLeft: -10 }} value='Oops!' />
              <Text style={{ fontSize: '24px', fontWeight: 'bold', color: '#1e293b', position: 'absolute', top: 200 }} value='Qualcosa è andato storto.' />
            </Flex>
            <Flex fw as>
              <Text
                style={{ fontSize: '16px', color: '#1e293b' }}
                value='Non siamo riusciti a trovare la pagina che stai cercando. '
              />
              <Text
                style={{ fontSize: '16px', color: '#1e293b' }}
                value='Ti preghiamo di riprovare o tornare alla home.'
              />
            </Flex>
            <Flex js as row style={{ gap: '1em', marginTop: '2em' }}>
              <Button
                label='Torna alla Home'
                onClick={() => navigateHome('/')}
                style={{ backgroundColor: COLORS.white, color: COLORS.primary, borderRadius: 5, padding: '10px 20px' }}
              />
              <Button
                primary
                label='Riprova'
                onClick={() => window.location.reload()}
                style={{ backgroundColor: COLORS.primary, color: '#1e293b', borderRadius: 5, padding: '10px 20px' }}
              />
            </Flex>
          </Flex>
          <Flex>
            <img src={errorImage} alt='Error' style={{ width: '100%' }} />
          </Flex>
        </Flex>
      </Card>
    </Flex>
  )
}

export default ErrorHandler
